import ButtonDropdown from "./ButtonDropdown";
import React, { useEffect } from "react";
import { useAuth } from "context/auth";

type Props = {};

const Header: React.FC<Props> = (): JSX.Element => {
  const { userName, reloadContextData } = useAuth();

  useEffect(() => {
    if (!userName) {
      reloadContextData();
    }
  }, [reloadContextData, userName]);

  return (
    <header
      className="flex bg-bt-white border border-l-white border-t-white border-b-light-gray"
      style={{ height: "76px" }}
    >
      <div className="flex flex-row w-full justify-end">
        <div className="flex flex-row items-center mr-6">
          <div className="flex flex-col mr-4">
            <div
              className="flex w-12 h-12 rounded-full font-sora font-medium justify-center items-center text-bt-white text-xl"
              style={{ background: "#408E5A" }}
            >
              {userName?.substring(0, 1)}
            </div>
          </div>
          <ButtonDropdown />
        </div>
      </div>
    </header>
  );
};

export default Header;
